import * as type from "../types/hqReport";
export const setViewBranch = branch => {
  return {
    type: type.SET_VIEW_BRANCH,
    payload: branch
  };
};
